<template>
  <a
    :href="$coconala.url('/requests/' + result.requestId)"
    target="_blank"
  >
    <div class="c-searchItem">
      <div class="c-itemInfo">
        <div class="c-itemInfo_category">
          <nuxt-link :to="genCategoryLink(result.childMasterCategoryId)">
            {{ getCategoryName(result.parentMasterCategoryId, result.childMasterCategoryId) }}
          </nuxt-link>
        </div>
        <div class="c-itemInfo_title">
          <a
            :href="$coconala.url('/requests/' + result.requestId)"
            target="_blank"
          >
            {{ result.title }}
          </a>
        </div>
        <div
          class="c-itemInfo_description"
          v-if="!isSP"
        >
          {{ result.requestContent }}
        </div>
        <div class="c-itemInfoUser">
          <div class="c-itemInfoUser_icon">
            <c-user-icon
              :file-path="result.userIconPath"
              :size="32"
            />
          </div>
          <div class="c-itemInfoUser_detail">
            <div class="c-itemInfoUser_name">
              <a
                :href="'/users/' + result.userId"
                target="_blank"
                rel="noopener"
              >
                {{ result.userName }}
              </a>
            </div>
            <div class="c-itemInfoUser_info">
              <div class="c-itemInfoUser_created">
                <span>投稿日時：</span><span :title="$util.dayjs.unix(result.created).format('LLLL')">{{ $util.prettyDate(result.created) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="c-itemDetail">
        <div class="c-itemTile">
          <div class="c-itemTile_tile c-itemTile_tile-budget">
            <div class="c-itemTile_icon">
              <coconala-icon name="yen-circle" />
            </div>
            <div class="c-itemTile_caption">
              予算
            </div>
            <div class="c-itemTileContent">
              <div class="c-itemTileContent_inner c-itemTileContent_inner-budget">
                <DRequestPrice
                  :price-min="result.minBudget"
                  :price-max="result.maxBudget"
                  add-br
                />
              </div>
            </div>
          </div>
          <div class="c-itemTile_tile c-itemTile_tile-proposalCount">
            <div class="c-itemTile_icon">
              <coconala-icon name="comment" />
            </div>
            <div class="c-itemTile_caption">
              提案数
            </div>
            <div class="c-itemTileContent">
              <div class="c-itemTileContent_inner c-itemTileContent_inner-proposalCount">
                <div class="c-itemTileLine c-itemTileLine-proposalCount">
                  <span class="c-itemTileLine_emphasis c-itemTileLine_emphasis-proposalCount">
                    {{ $util.numberWithDelimiter(result.proposalCount) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="c-itemTile_tile c-itemTile_tile-remainingDays">
            <div class="c-itemTile_icon">
              <coconala-icon name="calender" />
            </div>
            <div class="c-itemTile_caption">
              募集期限
            </div>
            <div class="c-itemTileContent">
              <div class="c-itemTileContent_inner c-itemTileContent_inner-remainingDays">
                <div
                  class="c-itemTileLine"
                  v-if="result.isRecruitmentFinished"
                >
                  <div class="c-itemTileLine_remainingFinished">
                    <span class="c-itemTileLine_emphasis c-itemTileLine_emphasis-remainingFinished">募集終了</span>
                  </div>
                </div>
                <div
                  class="c-itemTileLine"
                  v-else
                >
                  <div
                    class="c-itemTileLine_remainingShortly"
                    v-if="calcRemainingDays(result.recruitmentDeadline) < 1"
                  >
                    <span class="c-itemTileLine_emphasis c-itemTileLine_emphasis-remainingShortly">本日終了</span>
                  </div>
                  <div
                    class="c-itemTileLine_remainingDays"
                    v-else
                  >
                    あと<span class="c-itemTileLine_emphasis c-itemTileLine_emphasis-remainingDays">{{ calcRemainingDays(result.recruitmentDeadline) }}</span>日
                  </div>
                  <div class="c-itemTileLine_remainingDate">
                    （{{ $util.dayjs.unix(result.recruitmentDeadline).format('MMMDo') }}まで）
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="c-itemDetail_more">
          <a
            :href="$coconala.url('/requests/' + result.requestId)"
            target="_blank"
          >
            詳細を見る
            <coconala-icon name="chevron-right" />
          </a>
        </div>
      </div>
    </div>
  </a>
</template>
<script>
import { mapGetters } from 'vuex'
import DRequestPrice from '~/components/molecules/DS2/DRequestPrice'

export default {
  name: 'RequestSearchItem',
  components: {
    DRequestPrice
  },
  props: {
    result: {
      type: Object
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('ui', ['isSP'])
  },
  methods: {
    getCategoryName(pid, cid) {
      if (!pid) {
        return ''
      }
      const parentCategory = this.$store.state.master.masterCategories.find(
        masterCategory => masterCategory.id === pid
      )
      if (parentCategory.subCategories.length) {
        return parentCategory.subCategories.find(c => c.id === cid).name
      } else {
        return parentCategory.name
      }
    },
    genCategoryLink(id) {
      const category = { categoryId: id }
      return {
        path: `/requests/categories/${this.result.childMasterCategoryId}`,
        query: { ...this.$route.query, ...category, page: 1 }
      }
    },
    calcRemainingDays(date) {
      const diff = this.$util.dayjs.unix(date).diff(this.$util.dayjs())
      return Math.floor(this.$util.dayjs.duration(diff).asDays())
    }
  }
}
</script>
<style lang="scss" scoped>
.c-searchItem {
  position: relative;
  display: flex;
  margin-top: 16px;
  padding: 24px 32px;
  max-width: 952px;
  border-radius: 6px;
  background-color: $color-white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  color: $color-gray-900;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

  justify-content: space-between;

  a {
    @include link-effect;
  }
}

.c-itemInfo {
  flex: 1;
  padding-right: 50px;
  min-width: 110px;
  word-break: break-word;

  &_category {
    margin-bottom: 8px;
    font-size: 11px;
  }

  &_title {
    a {
      display: block;
      margin-bottom: 8px;
      color: $color-gray-900;
      font-weight: bold;
      font-size: 19px;
      line-height: 1.32;
    }
  }

  &_description {
    overflow: hidden;
    margin-bottom: 32px;
    max-height: 32px;
    color: $color-gray-700;
    font-size: 12px;
    line-height: 1.42;
  }
}

.c-itemInfoUser {
  z-index: 10;
  display: flex;

  &_icon {
    margin-right: 4px;

    flex-basis: 32px;

    img {
      width: 32px;
      height: 32px;
      border-radius: 50%;
    }
  }

  &_name {
    font-size: 11px;

    a {
      color: $color-gray-900;
      text-decoration: underline;
    }
  }

  &_info {
    font-size: 10px;
  }
}

.c-itemDetail {
  position: relative;
  padding-top: 23px;

  flex-basis: 352px;

  &_more {
    text-align: right;
    font-size: 12px;

    .coconala-icon {
      font-size: 11px;
    }
  }
}

.c-itemTile {
  display: flex;
  margin-bottom: 18px;
  width: 100%;

  &_tile {
    margin-right: 8px;
    padding: 4px;
    height: 128px;
    border: 1px solid $color-gray-100;
    border-radius: 6px;
    background-color: $color-gray-50;

    flex-basis: 112px;

    &-remainingDays {
      margin-right: 0;
    }
  }

  &_icon {
    margin-top: 12px;
    height: 20px;
    color: $color-blue-600;
    text-align: center;

    .coconala-icon {
      font-size: 20px;
    }
  }

  &_caption {
    margin-top: 8px;
    color: $color-gray-700;
    text-align: center;
    font-size: 12px;
  }
}

.c-itemTileContent {
  display: flex;
  margin-top: 12px;
  height: 40px;

  &_inner {
    text-align: center;
    font-size: 11px;
    line-height: 1.4;

    align-self: center;
    flex-basis: 100%;
  }
}

/deep/ .d-requestPrice {
  color: $color-gray-900;
  font-size: 10px;

  &_emphasis {
    color: $color-blue-600;
    font-weight: bold;
    font-size: 13px;
  }
}

.c-itemTileLine {
  &_emphasis {
    color: $color-blue-600;
    font-weight: bold;
    font-size: 13px;

    &-proposalCount {
      font-size: 18px;
    }

    &-remainingDays {
      padding: 0 4px;
      font-size: 18px;
    }

    &-remainingShortly {
      padding: 0 4px;
      font-size: 14px;
    }

    &-remainingFinished {
      padding: 0 4px;
      color: $color-gray-900;
      font-weight: normal;
      font-size: 14px;
    }
  }
}

@media (min-width: breakpoint(Requests, S)) {
  .c-searchItem {
    &:hover {
      background-color: $color-bg-pale;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    }
  }
}

@media (min-width: breakpoint(Requests, S)) and (max-width: breakpoint(Requests, M)) {
  .c-searchItem {
    display: block;
  }

  .c-itemInfo {
    padding-right: 0;

    &_description {
      margin-bottom: 0;
    }
  }

  .c-itemInfoUser {
    position: absolute;
    bottom: 16px;
  }

  .c-itemDetail {
    padding-top: 12px;

    flex-basis: 100%;
  }

  .c-itemTile {
    margin-bottom: 24px;

    &_tile {
      flex: 1;
      margin-right: 2%;

      &-remainingDays {
        margin-right: 0;
      }
    }
  }
}

@media (max-width: breakpoint(Requests, S)) {
  .c-searchItem {
    display: block;
    margin: 4px 0 8px;
    padding: 16px;
    border: 0;
    border-radius: 0;
    box-shadow: inset 0 -1px 0 0 $color-gray-300, inset 0 0.5px 0 0 $color-gray-300;
  }

  .c-itemInfo {
    padding-right: 0;

    &_category {
      margin-bottom: 0;
    }

    &_title {
      a {
        margin-bottom: 0;
        padding: 4px 0;
        font-size: 16px;
      }
    }

    &_description {
      margin-bottom: 0;
    }
  }

  .c-itemInfoUser {
    position: absolute;
    bottom: 16px;
  }

  .c-itemDetail {
    padding-top: 0;

    flex-basis: 100%;

    &_more {
      a {
        display: inline-block;
        padding: 4px 0;
      }
    }
  }

  .c-itemTile {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;

    &_tile {
      display: flex;
      flex: 1;
      margin-right: 0;
      max-height: 37px;
      border-top: none;
      border-right: none;
      border-left: none;
      border-radius: 0;
      background-color: $color-white;
    }

    &_icon {
      margin-top: 0;
      margin-right: 4px;
      padding-top: 4px;
      height: 28px;

      flex-basis: 14px;

      .coconala-icon {
        font-size: 14px;
      }
    }

    &_caption {
      overflow: hidden;
      margin-top: 0;
      margin-right: 4px;
      padding-top: 1px;
      height: 28px;
      text-align: left;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 28px;

      flex-basis: 50px;
    }
  }

  .c-itemTileContent {
    margin-top: 0;
    height: 28px;

    &_inner {
      display: flex;
      height: 28px;
      line-height: 28px;

      align-self: baseline;

      /deep/ .d-requestPrice {
        &_br {
          display: none;
        }
      }
    }
  }

  .c-itemTileLine {
    align-self: baseline;

    &_budget {
      display: inline-block;
    }

    &_remainingDays {
      display: inline-block;
    }

    &_remainingShortly {
      display: inline-block;
      padding-top: 1px;
      height: 28px;
    }

    &_remainingDate {
      display: inline-block;
    }

    &_remainingFinished {
      display: inline-block;
      padding-top: 1px;
      height: 28px;
    }

    &_emphasis {
      display: inline-block;

      &-proposalCount {
        font-size: 13px;
      }

      &-remainingDays {
        font-size: 13px;
      }

      &-remainingShortly {
        padding: 0;
        font-size: 11px;
      }

      &-remainingFinished {
        padding: 0;
        font-size: 11px;
      }
    }
  }
}
</style>
